// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"485":"79d5ca2e","728":"ba295836","912":"de8b79ef"}[chunkId] + ".chunk.js";
};